<template>
    <div class="">



        <svg class="progress-ring"
             :width="width_n"
             :height="width_n">


            <circle class="progress-ring__circle"
                    stroke="gray"
                    stroke-width="6"
                    fill="white"
                    :r="co_circleRadius_n"
                    cx="50%"
                    cy="50%"/>

            <circle class="progress-ring__circle"
                    :style="{'stroke-dasharray'  : co_strokeDasharray, 'stroke-dashoffset' : co_strokeDashoffset}"
                    stroke="green"
                    stroke-width="6"
                    fill="transparent"
                    :r="co_circleRadius_n"
                    cx="50%"
                    cy="50%"/>

            <text :x="width_n/2" :y="width_n/2+2" dominant-baseline="middle" text-anchor="middle" class="TQ_text_bold">{{p_totalTime_n-secondPass_n}}</text>


        </svg>

    </div>
</template>

<script>
    import {date_doEveryClockTick_addCb_f, date_doEveryClockTick_removeCb_f} from "../../scripts/S_Date";

    export default {
        name: "TqTimer",
        props:{
            p_secondPass_n:{
                type: Number,
                require: true
            },
            p_totalTime_n:{
                type: Number,
                require: true
            },
            pe_timeOver_f:{
                type: Function,
                require: true
            }
        },
        data(){
            return {
                secondPass_n: this.p_secondPass_n,
                width_n : 70,
            }
        },
        computed:{
            co_circleRadius_n(){
                return this.width_n /2 - 8
            },
            co_wrapperStyle_o(){
                if(this.co_progressPercentage_n > 0.5){
                    return {clip : "rect(auto, auto, auto, auto)"}
                }else{
                    return {clip : "rect(0px, 100px, 100px, 54px)"}
                }
            },
            co_rightStyle_o(){

                if(this.co_progressPercentage_n > 0.5){
                    return { '-webkit-transform': 'rotate(180deg)'}
                }else{
                    return { '-webkit-transform': 'rotate(' + this.co_progressPercentage_n*360 + 'deg)'}
                }

            },
            co_leftStyle_o(){

                if(this.co_progressPercentage_n > 0.5){
                    return { '-webkit-transform': 'rotate(' + this.co_progressPercentage_n*360 + 'deg)'}
                }else{
                    return {'-webkit-transform': 'rotate(0deg)'}
                }

            },
            co_progressPercentage_n(){
                return (this.p_totalTime_n-this.secondPass_n) / this.p_totalTime_n
            },
            co_circumference_n(){
                return this.co_circleRadius_n * 2 * Math.PI
            },
            co_strokeDashoffset(){

                const offset = (this.co_circumference_n) - this.co_progressPercentage_n * this.co_circumference_n;

                return `${offset}`
            },
            co_strokeDasharray(){
                return `${this.co_circumference_n} ${this.co_circumference_n}`
            }
        },
        created(){

            date_doEveryClockTick_addCb_f(this.$options.name, () => {
                this.secondPass_n++;

                if(this.secondPass_n >= this.p_totalTime_n) {
                    date_doEveryClockTick_removeCb_f(this.$options.name)
                    this.pe_timeOver_f()
                }
            })

        }
    }
</script>

<style scoped>


    .progress-ring__circle {
        transition: 0.35s stroke-dashoffset;
        transform: rotate(-90deg);
        transform-origin: 50% 50%;
    }


</style>